export default "/reward-coins-bg.80a54a70671b471b815da7230473d39c.png";